const payment = [
    {value: "(Cash)",text:"(Cash)"},
    {value: "(Cheque)",text:"(Cheque)"},
    {value: "(RTGS)",text:"(RTGS)"},
    {value: "(Phonepe/GPay)",text:"(Phonepe/Gpay)"},
]

export default payment;